<template>
  <div
    class="w-100 tw-flex item-c cursor-pointer tw-overflow-hidden tw-p-4"
    @click="handleToProductDetail(item)"
  >
    <img
      v-if="isShowIcon"
      class="tw-hidden lg:tw-block tw-w-6 tw-h-6 tw-flex-none tw-mr-2.5"
      :src="item.icon || '/icon-se.png'"
      alt=""
    />
    <div class="tw-flex-1">
      <span
        class="fontstylewrapmore-1 item-title tw-text-sm tw-text-textLight"
        >{{ getTitle(item) }}</span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "MobileSelectItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isShowIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getTitle(item) {
      return item.title || item.name;
    },
    getDesc(item) {
      return item.intro || "暂无描述";
    },
    handleToProductDetail(child) {
      this.$emit("onSelect", child);
    },
  },
};
</script>

<style scoped lang="scss">
.item-c:hover {
  border-radius: 6px;
  box-shadow: 0 0 10px 0 rgba(64, 119, 248, 0.2);

  .item-title {
    color: #4077f8 !important;
  }
}
</style>
